import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageOverviewContent from "./PackageOverviewContent";

const MembershipOverviewPage = () => (
  <PackageOverviewContent
    type="membership"
    title={translate("analyticsPage.membership.report_overview")}
    backTo={PATHS.ANALYTICS}
  />
);

export default MembershipOverviewPage;
